export const comments = [
  {
    id: 1,
    name: '影迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20casual%20style%20warm%20lighting%20clean%20background%20natural%20expression%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '四虎影视大全实在太方便了！资源更新速度超快，昨天刚上映的大片今天就能在上面找到高清版本。画质清晰流畅，加载速度也没得说，强烈推荐给所有喜欢看电影的朋友！',
    movie: '《流浪地球3》',
    time: '2小时前',
  },
  {
    id: 2,
    name: '电影控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%2020s%20casual%20portrait%20with%20glasses%20friendly%20smile%20clean%20studio%20background%20soft%20light&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '用了好几个影视平台，最后还是回到了四虎影视大全。分类清晰，片源丰富，从经典老片到热门新片应有尽有。关键是免费观看不设限，真的是影迷的福音。',
    movie: '《封神第二部》',
    time: '5小时前',
  },
  {
    id: 3,
    name: '周末追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20natural%20makeup%20warm%20smile%20clean%20white%20background%20soft%20natural%20lighting%20professional&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '四虎影视大全的影片画质真的很赞，1080P高清看着特别过瘾。最近在追几部国产大片，更新很及时，而且没有广告打扰观影体验，赞一个！希望继续保持这个更新频率。',
    movie: '《长津湖之水门桥》',
    time: '昨天',
  },
  {
    id: 4,
    name: '老影虫',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%20in%20his%2040s%20warm%20expression%20clean%20background%20natural%20light%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '作为一个看了二十多年电影的老影迷，四虎影视大全的片库深度让我惊喜。很多冷门佳作和经典修复版都能找到，而且分类做得特别用心。推荐给所有真正热爱电影的人。',
    movie: '《满江红》',
    time: '2天前',
  },
];

export const cards = [
  {
    id: 1,
    title: '动作大片专区',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20scene%20with%20dramatic%20lighting%20explosive%20visual%20effects%20warm%20red%20and%20orange%20tones%20film%20poster%20style%20epic%20composition%20dynamic%20movement%20professional%20movie%20photography&width=800&height=500&seq=card-action-01&orientation=landscape',
    category: '动作',
    description: '热血沸腾的动作巨制，从好莱坞到大中华，精选高分动作大片',
    tag: '本周热播',
  },
  {
    id: 2,
    title: '悬疑烧脑剧场',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20mystery%20thriller%20film%20scene%20with%20dramatic%20shadows%20warm%20amber%20accents%20cinematic%20lighting%20suspenseful%20atmosphere%20film%20noir%20aesthetic%20professional%20movie%20photography&width=800&height=500&seq=card-suspense-02&orientation=landscape',
    category: '悬疑',
    description: '烧脑剧情层层反转，每一部都让你屏息凝神看到最后一秒',
    tag: '高分推荐',
  },
  {
    id: 3,
    title: '喜剧欢乐合集',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20movie%20scene%20warm%20lighting%20cheerful%20atmosphere%20cinematic%20composition%20joyful%20expressions%20film%20poster%20style%20vibrant%20warm%20colors%20professional&width=800&height=500&seq=card-comedy-03&orientation=landscape',
    category: '喜剧',
    description: '笑料不断，解压首选。汇集国内外经典喜剧，陪你度过欢乐时光',
    tag: '人气爆款',
  },
  {
    id: 4,
    title: '科幻视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20space%20elements%20warm%20golden%20and%20amber%20lighting%20cinematic%20epic%20scale%20dramatic%20composition%20film%20poster%20style%20professional%20photography&width=800&height=500&seq=card-scifi-04&orientation=landscape',
    category: '科幻',
    description: '脑洞大开的科幻世界，震撼特效带你探索未知宇宙',
    tag: '特效大片',
  },
  {
    id: 5,
    title: '爱情经典回眸',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20warm%20sunset%20lighting%20soft%20golden%20tones%20cinematic%20composition%20intimate%20atmosphere%20film%20poster%20style%20elegant%20warm%20colors%20professional%20photography&width=800&height=500&seq=card-romance-05&orientation=landscape',
    category: '爱情',
    description: '感人至深的爱情故事，经典与新作一网打尽',
    tag: '治愈推荐',
  },
  {
    id: 6,
    title: '动画奇幻世界',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20scene%20with%20fantasy%20elements%20warm%20vibrant%20colors%20cinematic%20composition%20magical%20atmosphere%20film%20poster%20style%20bright%20cheerful%20professional%20illustration&width=800&height=500&seq=card-anime-06&orientation=landscape',
    category: '动画',
    description: '国漫崛起遇上世界经典，全家人都能找到喜爱的动画',
    tag: '家庭必看',
  },
];

export const ranking = [
  { rank: 1, title: '流浪地球3', category: '科幻 / 冒险', score: '9.3', trend: 'up' as const },
  { rank: 2, title: '封神第二部：战火西岐', category: '奇幻 / 史诗', score: '9.1', trend: 'up' as const },
  { rank: 3, title: '热辣滚烫', category: '喜剧 / 励志', score: '8.9', trend: 'same' as const },
  { rank: 4, title: '第二十条', category: '剧情 / 法律', score: '8.8', trend: 'up' as const },
  { rank: 5, title: '飞驰人生2', category: '喜剧 / 赛车', score: '8.7', trend: 'down' as const },
  { rank: 6, title: '熊出没·逆转时空', category: '动画 / 冒险', score: '8.6', trend: 'up' as const },
  { rank: 7, title: '年会不能停！', category: '喜剧 / 职场', score: '8.5', trend: 'same' as const },
];

export const topics = [
  { id: 1, name: '科幻巨制', count: 12800 },
  { id: 2, name: '国产喜剧', count: 11500 },
  { id: 3, name: '悬疑推理', count: 10200 },
  { id: 4, name: '动作爽片', count: 9800 },
  { id: 5, name: '国漫崛起', count: 8600 },
  { id: 6, name: '经典修复', count: 7900 },
  { id: 7, name: '院线新片', count: 7400 },
  { id: 8, name: '高燃战争', count: 6800 },
  { id: 9, name: '治愈温情', count: 6200 },
];

export const about = {
  title: '关于四虎影视大全',
  paragraphs: [
    '四虎影视大全是一个专注为广大影迷提供优质观影体验的在线影视平台。我们致力于打造一个片源丰富、更新及时、观影流畅的一站式电影大全，让每一位热爱电影的朋友都能在这里找到心仪的影片。',
    '平台涵盖动作、喜剧、科幻、悬疑、爱情、动画等全品类电影资源，从最新院线大片到经典修复佳作，从国产热门到海外精选，日均更新超过50部高清影片，片库总量持续增长。无论你是想看近期热门新片，还是回味记忆中的老电影，四虎影视大全都能满足你的需求。',
    '我们坚持高清画质标准，主流影片均提供1080P及以上清晰度选项，同时优化播放体验，确保流畅不卡顿。所有资源均可免费观看，无需注册登录，无需付费订阅，打开即看。',
  ],
  highlights: [
    { icon: 'ri-movie-2-line', label: '海量片库', value: '20000+ 部影片' },
    { icon: 'ri-4k-line', label: '高清画质', value: '1080P 起步' },
    { icon: 'ri-flashlight-line', label: '每日更新', value: '50+ 部新片' },
    { icon: 'ri-user-smile-line', label: '完全免费', value: '零门槛观影' },
  ],
};

export const updates = [
  {
    date: '2026-07-31',
    title: '《流浪地球3》高清版正式上线',
    description: '国产科幻巅峰之作第三部，视觉效果再升级，四虎影视大全全网首发高清资源。极致画质搭配流畅播放，带你重返浩瀚宇宙。',
  },
  {
    date: '2026-07-30',
    title: '暑期档专题"盛夏光影"重磅上线',
    description: '精选50部暑期必看大片，涵盖动作、喜剧、动画等多类型。炎炎夏日，四虎影视大全陪你吹着空调看大片。',
  },
  {
    date: '2026-07-28',
    title: '平台片库突破20000部里程碑',
    description: '四虎影视大全电影大全频道片库正式突破20000部，覆盖全球40+国家的优质影片，持续丰富你的观影选择。',
  },
  {
    date: '2026-07-25',
    title: '"经典修复"专区重磅升级',
    description: '新增300部经典电影高清修复版，《霸王别姬》《活着》等影史名作以全新画质回归，重温那些打动心灵的故事。',
  },
  {
    date: '2026-07-22',
    title: '国漫专区内容翻倍扩充',
    description: '《哪吒之魔童降世》《长安三万里》《深海》等热门国漫全系列上线，见证国漫崛起的每一个精彩瞬间。',
  },
  {
    date: '2026-07-20',
    title: '播放体验全面优化',
    description: '四虎影视大全完成播放器技术升级，加载速度提升40%，支持智能清晰度切换，观影体验更加丝滑流畅。',
  },
  {
    date: '2026-07-18',
    title: '悬疑烧脑专题"暗夜迷踪"上线',
    description: '汇集国内外高分悬疑大片，从经典推理到现代心理惊悚，每一部都让你欲罢不能。烧脑指数爆表，你敢来挑战吗？',
  },
];

export const faqs = [
  {
    question: '四虎影视大全上的电影真的全部免费吗？',
    answer: '是的，四虎影视大全所有电影资源均免费观看。我们致力于为广大影迷提供零门槛的观影体验，无需注册、无需付费、无需订阅，打开网站即可畅享海量高清影片。我们通过广告合作维持平台运营，绝不会向用户收取任何费用。',
  },
  {
    question: '影片的画质怎么样？支持哪些清晰度？',
    answer: '四虎影视大全主流影片均提供1080P全高清画质，部分热门大片支持4K超高清。我们采用先进的视频编码技术，在保证清晰度的同时优化了加载速度，即使网速一般也能流畅观看。播放器支持智能清晰度切换，可以根据你的网络状况自动调整。',
  },
  {
    question: '新电影上线后多久能在平台上看到？',
    answer: '四虎影视大全拥有高效的资源更新团队，热门院线大片通常在下映后1-2周内即可上线高清版本。部分热门影片我们还会提前准备资源，确保第一时间为影迷呈现。每日更新量超过50部，让你始终能看到最新最热的影片。',
  },
  {
    question: '在手机上观看体验怎么样？',
    answer: '四虎影视大全已全面适配移动端，无论是手机还是平板都能获得出色的观影体验。页面响应式设计自动适配不同屏幕尺寸，播放器针对移动网络做了专项优化，在4G/5G网络下也能流畅播放高清影片。我们还提供了移动端快捷入口，方便随时随地点开就看。',
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '如果你有任何影片推荐、资源反馈或合作咨询，欢迎通过以下方式联系四虎影视大全团队。我们珍视每一位影迷的声音，期待与你交流。',
  email: 'feedback@sihumovies.com',
  wechat: 'sihumovies',
  tips: [
    '影片推荐 & 求片反馈',
    '资源问题 & 播放故障',
    '广告合作 & 商务洽谈',
    '版权相关 & 内容申诉',
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: '《流浪地球3》幕后特辑：打造中国科幻新高度',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20sci-fi%20movie%20production%20warm%20dramatic%20lighting%20film%20set%20atmosphere%20professional%20movie%20photography%20epic%20scale%20composition&width=900&height=506&seq=media-wandering-01&orientation=landscape',
    duration: '15:32',
    description: '探秘国产科幻巅峰之作的幕后故事，导演郭帆讲述创作历程',
  },
  {
    id: 2,
    title: '2026暑期档观影指南：哪些大片值得期待',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20preview%20montage%20style%20warm%20golden%20lighting%20film%20poster%20collage%20aesthetic%20professional%20movie%20photography%20vibrant%20atmosphere&width=900&height=506&seq=media-summer-02&orientation=landscape',
    duration: '22:08',
    description: '一网打尽暑期档最值得关注的电影作品，帮你规划观影清单',
  },
  {
    id: 3,
    title: '经典电影修复技术揭秘：老片如何焕发新生',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20restoration%20process%20cinematic%20warm%20lighting%20old%20movie%20reels%20professional%20photography%20nostalgic%20atmosphere%20classic%20film%20aesthetic%20detailed%20composition&width=900&height=506&seq=media-restoration-03&orientation=landscape',
    duration: '18:45',
    description: '从胶片到数字，现代技术如何让老电影焕发全新生命力',
  },
];

export const appInfo = {
  title: '随时随地 畅享电影',
  description: '四虎影视大全移动端全面适配，无需下载APP，浏览器打开即可享受完整观影体验。在手机上同样拥有高清画质和流畅播放，随时随地看大片。',
  features: ['高清流畅播放', '智能清晰度适配', '书签收藏功能', '观影历史记录'],
};

export const carouselItems = [
  {
    id: 1,
    title: '科幻纪元：探索未来的无限可能',
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20futuristic%20space%20elements%20warm%20golden%20and%20amber%20lighting%20dramatic%20composition%20film%20poster%20quality%20professional%20movie%20photography%20grand%20scale&width=1200&height=600&seq=carousel-scifi-01&orientation=landscape',
    description: '从《流浪地球》到《星际穿越》，精选20部不可错过的科幻经典，带你遨游想象力的边界。',
    tag: '专题精选',
  },
  {
    id: 2,
    title: '笑傲暑期：喜剧电影狂欢季',
    image: 'https://readdy.ai/api/search-image?query=Bright%20vibrant%20comedy%20movie%20collage%20warm%20sunny%20lighting%20cheerful%20atmosphere%20cinematic%20composition%20film%20poster%20style%20joyful%20colorful%20professional%20photography&width=1200&height=600&seq=carousel-comedy-02&orientation=landscape',
    description: '炎炎夏日，来一场开怀大笑！汇集年度最搞笑喜剧片，笑到停不下来。',
    tag: '暑期特辑',
  },
  {
    id: 3,
    title: '国漫之光：从大圣到哪吒的崛起之路',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20epic%20scene%20with%20mythological%20elements%20warm%20dramatic%20lighting%20cinematic%20composition%20rich%20colors%20film%20poster%20quality%20professional%20illustration%20style&width=1200&height=600&seq=carousel-anime-03&orientation=landscape',
    description: '见证国漫十年蜕变，从《大圣归来》到《长安三万里》，每一部都是骄傲。',
    tag: '国漫崛起',
  },
  {
    id: 4,
    title: '肾上腺素：动作硬核观影指南',
    image: 'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20scene%20with%20explosive%20visuals%20warm%20intense%20lighting%20cinematic%20epic%20composition%20film%20poster%20quality%20dynamic%20movement%20professional%20photography&width=1200&height=600&seq=carousel-action-04&orientation=landscape',
    description: '枪战、追车、格斗、特技，给你最纯粹的动作片观影体验，燃爆每一个细胞。',
    tag: '硬核推荐',
  },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '纯净观影环境，无弹窗、无恶意跳转，专注电影本身。所有片源经过安全检测，放心观看。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    description: '全球CDN加速节点覆盖，智能线路选择，确保在任何网络环境下都能快速缓冲，秒开即看。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    description: '20000+部影片持续增长，覆盖全球40余国家地区，类型齐全、更新及时，总有一部合你口味。',
  },
];

export const indexItems = [
  {
    letter: '动',
    items: [
      { name: '动作冒险', count: 3200 },
      { name: '动画电影', count: 1800 },
      { name: '谍战特工', count: 950 },
    ],
  },
  {
    letter: '科',
    items: [
      { name: '科幻巨制', count: 1600 },
      { name: '科幻惊悚', count: 720 },
      { name: '奇幻史诗', count: 1100 },
    ],
  },
  {
    letter: '喜',
    items: [
      { name: '喜剧搞笑', count: 2400 },
      { name: '喜剧爱情', count: 1300 },
      { name: '黑色幽默', count: 580 },
    ],
  },
  {
    letter: '悬',
    items: [
      { name: '悬疑推理', count: 1500 },
      { name: '心理惊悚', count: 890 },
      { name: '犯罪剧情', count: 2100 },
    ],
  },
  {
    letter: '爱',
    items: [
      { name: '爱情浪漫', count: 1800 },
      { name: '青春校园', count: 960 },
      { name: '家庭温情', count: 1100 },
    ],
  },
  {
    letter: '战',
    items: [
      { name: '战争史诗', count: 850 },
      { name: '历史传记', count: 620 },
      { name: '灾难求生', count: 480 },
    ],
  },
  {
    letter: '恐',
    items: [
      { name: '恐怖惊悚', count: 920 },
      { name: '丧尸末日', count: 430 },
      { name: '灵异鬼怪', count: 560 },
    ],
  },
  {
    letter: '纪',
    items: [
      { name: '纪录写实', count: 1100 },
      { name: '自然地理', count: 380 },
      { name: '人文社会', count: 520 },
    ],
  },
  {
    letter: '经',
    items: [
      { name: '经典修复', count: 780 },
      { name: '获奖佳片', count: 650 },
      { name: '影史名作', count: 420 },
    ],
  },
];

export const navLinks = [
  { label: '关于我们', href: '#about' },
  { label: '常见问答', href: '#faq' },
  { label: '精彩视频', href: '#media' },
  { label: '热播榜单', href: '#ranking' },
  { label: '最新动态', href: '#updates' },
  { label: '话题广场', href: '#topics' },
];